module.exports = __webpack_public_path__ + "img/ryzs5.d1a04461.jpg";